import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, FormTypeEdit, PageSize, StatusCodeActive } from "utils/Constant";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers"
import { useModal } from "context/ModalContext";
import { useCallApi } from "api/apiHooks";
import { FilterCard, MainBodyCard, PagesTitle } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import GridEditButton from "components/Button/GridEditButton";
import GridDeleteButton from "components/Button/GridDeleteButton";
import DataTable from "components/DataTable";
import AddButton from "components/Button/AddButton";

export default function Category(){
    let navigate = useNavigate()
    
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCategoryList, fetchDeleteCategory } = useCallApi()

    const [categoryList, setCategoryList] = useState([])
    const [categoryName, setCategoryName] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center",
        },
        {
            key: "categoryName",
            header: "Category"
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.salesStockId, row.status)} size="w-3" />
                </div>                
            ),
        },
    ]

    // Function Grid
    const handlePageChange = async (newIndex) => {
        const res = await fetchCategoryList(categoryName, status, PageSize, newIndex)
        if (!res) return
        
        const totalData = res?.data?.totalData ?? 0;
        const total = Math.max(1, Math.ceil(totalData / PageSize))

        setCategoryList(res)
        setTotalPages(total)
        setPageIndex(newIndex)
    }

    // Button Event
    const addBtnClick = () => {
        navigate("/category/form?categoryId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/category/form?categoryId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = async (id, status) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            const res = await fetchDeleteCategory(id, status)
            if (!res) return 

            showSuccess({
                onSuccess: async () => {
                    await handlePageChange(pageIndex)
                }
            })
        }
        finally {
            hideLoading()
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                await handlePageChange(0)
            }
            finally {
                hideLoading()
            }
        }

        onLoad()
    },[categoryName, status])

    return(
        <MainBodyCard>
            <PagesTitle title='Category' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Category Name'>
                        <input className="input" value={categoryName} onChange={(e) => { setCategoryName(e.target.value) }} />
                    </FilterCard>
                    <FilterCard title='Status' width='w-full sm:w-32'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </FilterCard>
                </div>
            </div>

            <div className="flex w-full justify-end mt-4">
                <AddButton onClick={addBtnClick} text={'Tambah Category'} />
            </div>

            <div className="mt-5">
                <DataTable
                    columns={columns}
                    data={categoryList?.data?.listData ?? []}
                />
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </MainBodyCard>
    )
}